import {Component, EventEmitter, Input, Output} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule]
})
export class SwitchComponent {
    @Input() control: unknown; // FormControl
    @Input() group; // Group contenant le FormControle
    @Input() fcName: string; // Nom du FormControl

    @Input() textLabel: string; // Label when switch not checked or always if no textLabelChecked
    @Input() textLabelChecked: string; // Label when switch checked

    @Input() i = 0; // i si l'input est dans une boucle (pour éviter d'avoir 2 composants ayant le même id

    @Input() modelAttribute: unknown; // Valeur entrée
    @Output() modelAttributeChange = new EventEmitter(); // Valeur envoyée au parent

    @Input() disabled;

    get label(): string {
        if (this.textLabelChecked) {
            return this.modelAttribute ? this.textLabelChecked : this.textLabel;
        } else {
            return this.textLabel;
        }
    }

    change(newValue) {
        this.modelAttribute = newValue;
        this.modelAttributeChange.emit(newValue);
    }

    changeEvent(event) {
        this.change(event.target.checked);
    }

}
